import React from "react";
import { Menu } from "semantic-ui-react";

export const getMenuItem = (acctTheme, selected, title) =>
  acctTheme === 0 ? (
    <Menu.Item
      key={`Tab_${title}`}
      style={{
        fontSize: "12px",
        borderRadius: "10px 10px 0 0 !important",
      }}
      className={
        selected
          ? "classicTab selected_background"
          : "classicTab form_tab_unselected"
      }
    >
      {title}
    </Menu.Item>
  ) : (
    title
  );

export default getMenuItem;



// WEBPACK FOOTER //
// ./src/components/common/PageHelper.js